import { render, staticRenderFns } from "./myStrategy.vue?vue&type=template&id=7ff7cff4&scoped=true"
import script from "./myStrategy.vue?vue&type=script&lang=js"
export * from "./myStrategy.vue?vue&type=script&lang=js"
import style0 from "./myStrategy.vue?vue&type=style&index=0&id=7ff7cff4&prod&lang=scss"
import style1 from "./myStrategy.vue?vue&type=style&index=1&id=7ff7cff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff7cff4",
  null
  
)

export default component.exports